import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Location } from "../../../@types/location";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findAssignedLocations = createAsyncThunk(
  "templateDetail/findAssignedLocations",
  async (id: string, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { data: formSubmittedResponse } = await axiosInstance.get(`${api.baseURL}formsubmitted`, {
        params: {
          where: {
            form: id,
          },
        },
      });

      return formSubmittedResponse.map(({ location }: { location: Location }) => location);
    } catch (error) {}
  }
);
